import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, Table, Button, Input, Row, Col, Label } from 'reactstrap';
import { Archive, Trash2 } from 'react-feather';
import API_BASE_URL from '../../../Config/api';
import authHeader from '../../Customer/authHeader';

// Admin management of a customer's stores (reuses the stores table via customer_id).
const CustomerStoresManager = ({ customerId }) => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: '', location: '', country: '' });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/customers/${customerId}/stores`, authHeader());
      const data = await res.json();
      setStores(data.stores || []);
    } catch (e) {
      console.error('Failed to load stores', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (customerId) load(); }, [customerId]);

  const addStore = async () => {
    if (!form.name.trim()) { alert('Store name is required'); return; }
    setSaving(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/customers/${customerId}/stores`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader().headers },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error((await res.json()).error || 'Failed');
      setForm({ name: '', location: '', country: '' });
      load();
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  };

  const deleteStore = async (storeId) => {
    if (!window.confirm('Delete this store?')) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/customers/${customerId}/stores/${storeId}`, { method: 'DELETE', ...authHeader() });
      if (!res.ok) throw new Error((await res.json()).error || 'Failed');
      load();
    } catch (e) {
      alert(e.message);
    }
  };

  return (
    <Card>
      <CardHeader>
        <h5><Archive className="me-2" size={20} />Stores</h5>
      </CardHeader>
      <CardBody>
        <Row className="align-items-end mb-3">
          <Col md="4">
            <Label className="form-label">Store Name</Label>
            <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Store name" />
          </Col>
          <Col md="3">
            <Label className="form-label">Location</Label>
            <Input value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} placeholder="Location" />
          </Col>
          <Col md="3">
            <Label className="form-label">Country</Label>
            <Input value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} placeholder="Country" />
          </Col>
          <Col md="2">
            <Button color="primary" onClick={addStore} disabled={saving}>{saving ? 'Adding...' : 'Add Store'}</Button>
          </Col>
        </Row>

        {loading ? (
          <p className="text-muted mb-0">Loading...</p>
        ) : stores.length === 0 ? (
          <p className="text-muted mb-0">No stores yet.</p>
        ) : (
          <Table className="table-bordered">
            <thead><tr><th>Name</th><th>Location</th><th>Country</th><th>Actions</th></tr></thead>
            <tbody>
              {stores.map((s) => (
                <tr key={s.id}>
                  <td>{s.name}</td>
                  <td>{s.location || '-'}</td>
                  <td>{s.country || '-'}</td>
                  <td>
                    <Button color="danger" size="sm" onClick={() => deleteStore(s.id)}><Trash2 size={14} /></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardBody>
    </Card>
  );
};

export default CustomerStoresManager;
